function _slicedToArray(arr, i) {return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();}function _nonIterableRest() {throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr, i) {var _arr = [];var _n = true;var _d = false;var _e = undefined;try {for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"] != null) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}function _arrayWithHoles(arr) {if (Array.isArray(arr)) return arr;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from "./week-header.scss";
import template from "./week-header.html";
import { getMonday } from "../../../shared/helpers/date-time";

export var WeekHeaderComponent = {
  template: template,
  styles: styles,
  require: {
    model: "ngModel" },

  bindings: {
    currentDay: '<',
    disableDateHandler: '<',
    onChangeDay: "&",
    onChangeWeek: "&" },

  controller: /*#__PURE__*/function () {WeekHeaderComponentController.$inject = ["$filter", "$timeout", "$scope", "$state", "MealPlanService", "UserService", "MiscModel"];
    function WeekHeaderComponentController($filter, $timeout, $scope, $state, MealPlanService, UserService, MiscModel) {
      "ngInject";_classCallCheck(this, WeekHeaderComponentController);
      console.log(this);
      this.$filter = $filter;
      this.$timeout = $timeout;
      this.$scope = $scope;
      this.$state = $state;
      this.MealPlanService = MealPlanService;
      this.UserService = UserService;
      this.MiscModel = MiscModel;

      var today = this.today = new Date();
      this.todayTitle = this.$filter('date')(new Date(), 'EEEE, MMM. dd');
      this.currentWeek = this.$state.params.week || ''; // 'prev' || 'next'
      this.currentDay = this.$state.params.day;
      this.week = [];
      this.isWeekChanging = false;
      this.disableDateHandler = false;

      // this.currentDate = this.$filter('date')(new Date(), 'MM/dd/yyyy');
    }_createClass(WeekHeaderComponentController, [{ key: "$onChanges", value: function $onChanges(

      changes) {

      } }, { key: "$onInit", value: function $onInit()



      {var _this = this;
        // two way bindings change current date
        // this.model.$render = () => {
        // 	this.currentDate = this.model.$viewValue;
        // }

        this.MiscModel.get('twoWeeksAccelerator').then(function (res) {
          _this.twoWeeksAccelerator = true;
          _this.lastWeekNumber = _this.UserService.data.last_checkin.week_number;
        },
        function (err) {
          _this.twoWeeksAccelerator = false;
          _this.lastWeekNumber = _this.UserService.data.last_checkin.week_number;
        });

        if (this.currentDay) {
          var startOfWeek = new Date(this.UserService.data.last_checkin.created_at);
          var currentDate = new Date(startOfWeek.setDate(startOfWeek.getDate() + this.currentDay));
          this.todayTitle = this.$filter('date')(currentDate, 'EEEE, MMM. dd');
        }

        this.week = getWeekDays(this.UserService.data.last_checkin.created_at);
        this.$scope.$watch(function () {
          return _this.currentWeek;
        }, function (currentWeek, prevWeek, $scope) {
          console.warn('week changed', currentWeek, prevWeek);
          if (
          typeof currentWeek === 'undefined' ||
          currentWeek === prevWeek)
          return;
          _this.onCurrentWeekChanged(currentWeek);
        });
        this.onCurrentWeekChanged(this.currentWeek);
      } }, { key: "onSelectDay", value: function onSelectDay(

      day) {
        this.todayTitle = this.$filter('date')(day, 'EEEE, MMM. dd');
        this.currentDate = this.formatDate(day);
        this.model.$setViewValue(day);
      } }, { key: "onCurrentWeekChanged", value: function onCurrentWeekChanged(

      currentWeek) {var _this2 = this;
        this.isWeekChanging = true;var _ref =
        function () {
          switch (currentWeek) {
            case 'prev':return [-7, -1];
            case 'next':return [7, 1];
            default:return [0, 0];}

        }(),_ref2 = _slicedToArray(_ref, 2),offsetDay = _ref2[0],offsetWeek = _ref2[1];
        this.onChangeWeek({ offset: offsetWeek });
        this.$timeout(function () {
          _this2.isWeekChanging = false;
          _this2.week = getWeekDays(_this2.UserService.data.last_checkin.created_at, offsetDay);
        }, 600);
      } }, { key: "onLinkClick", value: function onLinkClick(

      type) {
        //if (this.weekNumber < 2 && type === 'prev') return false;
        this.currentWeek = this.getWeekSwitchType(type);
        return true;
      } }, { key: "formatDate", value: function formatDate(

      date) {
        return this.$filter('date')(new Date(date), 'MM/dd/yyyy');
      } }, { key: "getWeekSwitchType", value: function getWeekSwitchType(

      type) {
        return !this.currentWeek ?
        type : this.currentWeek === type ?
        type : '';
      } }, { key: "getWeekName", value: function getWeekName()

      {
        return {
          prev: 'Previous Week',
          next: 'Next Week' }[
        this.currentWeek] || 'Current Week';
      } }, { key: "getDayInWeek", value: function getDayInWeek(

      date) {
        var day = this.$filter('date')(date, 'EEE');
        return day[0];
      } }, { key: "isToday", value: function isToday(

      date) {
        var day = this.$filter('date')(date, 'dd');
        var today = this.$filter('date')(this.today, 'dd');
        return day === today;
      } }, { key: "weekNumber", get: function get() {return this.UserService.weekNumber;} }]);return WeekHeaderComponentController;}() };




function getWeekDays(_startOfWeek) {var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // const today = new Date(_startOfWeek);
  // const startOfWeek = new Date(_startOfWeek).getDate() + offset;

  var startOfWeek = new Date(_startOfWeek);
  return new Array(7).fill(0).
  map(function (day, i) {
    var date = new Date(startOfWeek);
    return {
      date: new Date(date.getFullYear(), date.getMonth(), date.getDate() + i + offset) };

  });
}